import React from 'react';
import PropTypes from 'prop-types';
import {emitEdapEvent, EVENTS} from "../../utils/emit-edap-event";
import {onAdsContextInit} from '../../services/targeting';
import {insertAdBlockTestScript, insertAdsLoaderScripts, removeMesoScripts} from '../../utils/meso-scripts'

export const Context = React.createContext(null);

export class MesoAdsContext extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            allowAds: false,
            gaiaId: props.gaiaId,
            isBrowser: typeof window !== 'undefined'
        };

        const {isBrowser} = this.state;
        if (isBrowser && props.isAdsEnabled) {
            insertAdBlockTestScript({
                onload: () => {
                    this.setState({allowAds: true});
                    window.meso.logging.push('Adblock: false');
                },
                onerror: () => {
                    this.setState({allowAds: false});
                    emitEdapEvent(EVENTS.BLOCKED);
                    window.meso.logging.push('Adblock: true');
                }
            });
            insertAdsLoaderScripts();
        }

        this.trackAdsViewByIframeClick = this.trackAdsViewByIframeClick.bind(this);
    }

    trackAdsViewByIframeClick () {
        const {gaiaId} = this.props;

        if (document.activeElement.tagName === 'MESO-DISPLAY-AD') {
            const mesoElement = document.activeElement;

            emitEdapEvent(EVENTS.SELECTED, {
                gaia_id: gaiaId,
                ad_placement: mesoElement.getAttribute('slot'),
                ad_uci: mesoElement.getAttribute('path')
            });
        }
    }

    componentDidMount() {
        /* istanbul ignore next */
        if (this.state.isBrowser) {
            const {brandId, locale, havId, gaiaId} = this.props;

            onAdsContextInit({brandId, locale, havId, gaiaId});

            window.addEventListener('blur', this.trackAdsViewByIframeClick);
        }
    }

    componentWillUnmount() {
        if (this.state.isBrowser) {
            window.removeEventListener('blur', this.trackAdsViewByIframeClick);
            removeMesoScripts();
        }
    }

    render() {
        return (
            <Context.Provider value={this.state}>
                {this.props.children}
            </Context.Provider>
        );
    }
}

MesoAdsContext.propTypes = {
    brandId: PropTypes.string.isRequired,
    locale: PropTypes.string.isRequired,
    havId: PropTypes.string.isRequired,
    gaiaId: PropTypes.string.isRequired,
    isAdsEnabled: PropTypes.bool.isRequired
};
